const navigationInitialState = {
  open:               false,
  behavior:           'full',
  expand:             [],
  menu:               {
    left:  [],
    right: [],
  },
  loading:            true,
  initialStateLoaded: false,
};

export default navigationInitialState;